// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-notification .el-notification__icon.el-icon-success,\n.el-notification .el-notification__icon.el-icon-error {\n  font-family: \"iconfont\" !important;\n}\n.el-notification .el-notification__icon.el-icon-success::before {\n  content: \"\\e016\";\n}\n.el-notification .el-notification__icon.el-icon-error::before {\n  content: \"\\e017\";\n}\n.el-notification .el-notification__closeBtn {\n  top: 15px;\n  right: 10px;\n}", ""]);
// Exports
module.exports = exports;
